import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../lib/queryClient";

interface QueryProviderProps {
  children: React.ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/*
        Optional: Install @tanstack/react-query-devtools for development tools
        npm install @tanstack/react-query-devtools
        Then uncomment the lines below:

        import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
        <ReactQueryDevtools initialIsOpen={false} />
      */}
    </QueryClientProvider>
  );
}
